import styles from "./Logo.module.scss";

import { Link, useHistory } from "react-router-dom";

function Logo(props) {
  const history = useHistory();

  const handleClick = (e) => {
    e.preventDefault();
    history.push("/home");
  };

  return (
    <a
      href="/home"
      className="logo-link"
      onClick={handleClick}
      style={{ pointerEvents: 'auto', cursor: 'pointer' }}
    >
      <img
        id="logo"
        className={[styles["logo"], ...props?.className].join(" ")}
        src="../../../assets/svgs/Kiritofy.svg"
        alt="Logo"
        height="77"
        width="75"
        style={{ pointerEvents: 'none' }}
      // {...props}
      />
    </a>
  );
}

export default Logo;

